import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

const NotFoundPage = () => {
    return (
        <section className="container error-page">
            <Helmet>
                <title>Not Found | Ailsa Lyn Artist</title>
                <meta name="description" content="This page does not exist" />
            </Helmet>
            <h2>404 Page Not Found</h2>
            <p>Oops... It appears this page does not exist.</p>
            <div className="row">
                <div className="col">
                    <Link to="/">Back to home >></Link>
                </div>
            </div>
        </section>
    );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js